<form [formGroup]="form" class="flex-col gap-4">
  <div class="flex-col lg-flex-row gap-4">
    <mat-form-field appearance="outline" class="section-form-field w-100" floatLabel="always">
      <mat-label>{{ 'generic.title' | translate }}</mat-label>
      <input type="text" formControlName="title" matInput>
    </mat-form-field>
    <mat-form-field appearance="outline" class="section-form-field w-100" floatLabel="always">
      <mat-label>{{ 'generic.subtitle' | translate }}</mat-label>
      <input type="text" formControlName="subtitle" matInput>
    </mat-form-field>
  </div>
  <div formArrayName="term" class="terms">
    @for (control of termFormArray.controls; track control; let index = $index) {
      <div [formGroupName]="index" class="term-container" >
        <mat-form-field appearance="outline" class="section-form-field w-100">
          <mat-label>{{ 'activity.section.glossary.word.label' | translate }}</mat-label>
          <input type="text" formControlName="name" matInput>
          <button
            type="button"
            matSuffix
            mat-icon-button
            [attr.aria-label]="'generic.remove' | translate"
            (click)="termFormArray.removeAt(index);"
            >
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
      </div>
    }
  </div>
</form>
